//STRAT GENAI@COPILOT
/**
 * This function takes a JWT token as input and returns the email or mobile identity hash from the payload.
 * It uses the atob function to decode the base64-encoded payload and JSON.parse to convert it into a JavaScript object.
 * If there is an error during decoding or parsing, it logs the error and returns null.
 *  This function is useful for extracting user information from JWT tokens, which are commonly used for authentication and authorization in web applications.
 * */

export const getHashedIdentityFromIdtoken = (jwtToken: string) => {
  try {
    const payload = JSON.parse(atob(jwtToken.split('.')[1]));
    return payload.email || payload.mobile;
  } catch (error) {
    // Handle error if the JWT token is invalid or cannot be decoded
    /*eslint-disable-next-line no-console*/
    console.error('Error decoding JWT:', error);
    return null;
  }
};
//END GENAI@COPILOT
